import React from "react";

const BusinessNotification = () => {
  return (
    <div className="pl-[1.8rem] pt-10  pb-10">
      <div className="flex justify-between w-[70%]">
        <section>
          <p className="text-[20px] font-[400] mb-[1rem]">
            Transaction notifications
          </p>
          <label
            className="container"
            style={{ fontSize: "14px", fontWeight: 400 }}
          >
            <div className="text-[14px] font-[600] text-[#444444]">
              Transaction emails
            </div>
            <div className="text-[14px] font-[300] text-[#444444]">
              Notify me for every transaction
            </div>
            <input type="radio" name="transactions" />
            <span className="checkmark" style={{ marginTop: "10px" }}></span>
          </label>
          <label
            className="container"
            style={{ fontSize: "14px", fontWeight: 400 }}
          >
            <div className="text-[14px] font-[600] text-[#444444]">
              Customer Receipt
            </div>
            <div className="text-[14px] font-[300] text-[#444444]">
              Email my customers for every transaction{" "}
            </div>
            <input type="radio" name="receipts" />
            <span className="checkmark" style={{ marginTop: "10px" }}></span>
          </label>
        </section>
        <section>
          <p className="text-[20px] font-[400] mb-[1rem]">Card notifications</p>
          <label
            className="container"
            style={{ fontSize: "14px", fontWeight: 400 }}
          >
            <div className="text-[14px] font-[600] text-[#444444]">
              Card Creation and Termination
            </div>
            <div className="text-[14px] font-[300] text-[#444444]">
              Notify me for every time a new card is created
              <br /> or terminated.
            </div>
            <input type="radio" name="cardCreation" />
            <span className="checkmark" style={{ marginTop: "10px" }}></span>
          </label>
          <label
            className="container"
            style={{ fontSize: "14px", fontWeight: 400 }}
          >
            <div className="text-[14px] font-[600] text-[#444444]">
              Card Transaction
            </div>
            <div className="text-[14px] font-[300] text-[#444444]">
              Notify me for every card transaction including card
              <br /> withdrawals, payments and funding.{" "}
            </div>
            <input type="radio" name="cardTransactions" />
            <span className="checkmark" style={{ marginTop: "10px" }}></span>
          </label>
        </section>
      </div>
      {/* <div className="mb-[3rem]">
        <p className="text-[20px] font-[400] mb-[1rem]">
          Transfer notifications
        </p>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Debit emails
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            Notify me for every transfer from my account
          </div>
          <input type="radio" name="debitemails" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Credit emails
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            Notify me for every transfer into my account
          </div>
          <input type="radio" name="creditemails" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
      </div> */}
      <div>
        <p className="text-[20px] font-[400] mb-[1rem]">
          Transactions notifications preferences
        </p>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Send to the business email address only.
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            Notify me for every transaction
          </div>
          <input type="radio" name="businessTran" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Send to all dashboard users
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            1 dashboard user{" "}
          </div>
          <input type="radio" name="dashboardUsers" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Send to all specific users
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            Select specific user{" "}
          </div>
          <input type="radio" name="selectedusers" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
      </div>
      <section className="">
        <div className="flex pt-10 mt-10">
          <button className="w-[272px] h-[42px] rounded-[8px] text-white bg-primary">
            Update
          </button>
        </div>
      </section>
    </div>
  );
};

export default BusinessNotification;
